var map = {
	"./0.png": 9128,
	"./1.png": 9345,
	"./10.png": 3045,
	"./11.png": 780,
	"./2.png": 8234,
	"./3.png": 5987,
	"./4.png": 6092,
	"./5.png": 2005,
	"./6.png": 6254,
	"./7.png": 8743,
	"./8.png": 7648,
	"./9.png": 2121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4473;